"use client";
import Heading from "@/components/molecules/Heading";
import React from "react";
import { InfoData } from "@/page-builder/fragments/HelpTextBlock/types";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";
import BupiLinkButton from "@/components/atoms/linkButton";
import Icon from "@/components/atoms/Icons";

export default function HelpText({ data }: { data: InfoData }) {

  return (
    <section className="bg-primary-100 relative overflow-hidden">
      <div className="container py-64 mx-auto max-w-5xl z-10 relative">
        <div className="grid xl:grid-cols-2 gap-16 xl:gap-32">
          <div className="col-span-4 md:col-span-8 xl:col-span-5">
            <Heading title={data.title} />
          
          </div>
          <div className="col-span-4 md:col-span-8 xl:col-span-6 xl:col-start-7">
            <div
              dangerouslySetInnerHTML={{
                __html: convertLexicalWithInternalLinks(
                  data.description as any
                ),
              }}
              className="text-m-regular text-neutral-900 mb-[24px] prose prose-ul:my-0 marker:text-neutral-900"
            />
            {data?.label !== "" && <div className="md:w-fit">
              <BupiLinkButton
                className=""
                label={data?.label}
                link={data?.url ?? "#"}
                target={data?.target || "_self"}
                hasIcon
                leadingIcon="agora-line-arrow-right-circle"
              /> 
            </div>
            }
          </div>
        </div>
      </div>
      <div className="w-full h-full absolute top-0 flex z-0">
        <div className="relative w-full h-full">
          <div
            className="  absolute 
          xl:top-0 xl:right-0 
          md:top-0 md:right-[-100px]
          top-[-280px] right-[-220px]
          "
          >
            <Icon name="fig19" />
          </div>
          <div
            className="absolute 
          xl:bottom-0 xl:left-0 
          md:bottom-[-130px] md:left-[-70px]
          bottom-[-180px] left-[-80px]
          "
          >
            <Icon name="fig20" />
          </div>
        </div>
      </div>
    </section>
  );
}
